import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import {
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    Table,
    Label
} from "reactstrap";
import moment from "moment";
import PaginationBlock2 from "../../../../../components/common/PaginationBlock2";
import { useSelector } from "react-redux";
import TimezoneClock from "../../../../../components/common/TimeZone";



const Listing = ({
    _sortFn,
    sort,
    order,
    documentLogs,
    page,
    limit,
    _handleLimit,
    _handlePageChange,
    documentLogDetail,
    _setDocumentLogDetail,
    fileData
}) => {

    console.log("documentLogs", documentLogs)
    const history = useHistory();
    const toggle = () => setModal(!modal);
    const modalToggleHandle = () => setModal(!modal);
    const [modal, setModal] = useState(false);
    // const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false)
    const isAdminLoggedIn = useSelector(state => state?.user?.user?.isAdminLoggedIn)
    const userDetail = useSelector((state) => state?.user?.user);
    // isAdminLoggedIn(isAdmin)


    const openModal = (item) => {

        _setDocumentLogDetail(item)
        console.log('version of modal', item)
        modalToggleHandle();
    };



    // original icons for sorting ==>

    // <span>
    //     {order != 1 ? (
    //         <span className='d-inline-flex up'>
    //             <img className='img-fluid' src={require('../../../../../assets/img/icons/arrow-triangle-fill-up.svg')} />
    //         </span>
    //     ) : (
    //         <span className='d-inline-flex down'>
    //             <img className='img-fluid' src={require('../../../../../assets/img/icons/arrow-triangle-fill-down.svg')} />
    //         </span>
    //     )}
    // </span>
    //                             ) : (
    // <span>
    //     <span className='d-inline-flex up'>
    //         <img className='img-fluid' src={require('../../../../../assets/img/icons/arrow-triangle-fill-up.svg')} />
    //     </span>
    //     <span className='d-inline-flex down'>
    //         <img className='img-fluid' src={require('../../../../../assets/img/icons/arrow-triangle-fill-down.svg')} />
    //     </span>
    // </span>


    return (
        <>
            <Table responsive>

                <thead>
                    <tr>
                        <th className='sort-heading' onClick={() => { _sortFn({ key: 'lname', order: order === -1 ? 1 : -1 }) }}>
                            <div className="sort-elem-cell d-inline-flex align-items-center">
                                UserName
                                <span className='sort-cell d-inline-flex flex-column align-items-center'>
                                    {sort === 'lname' ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">


                                                {(order != 1) ? <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />
                                                    :
                                                    <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />
                                                }

                                            </g>
                                        </svg>
                                    ) : <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                        <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">
                                            <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />

                                            <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />

                                        </g>
                                    </svg>

                                    }
                                </span>
                            </div>
                        </th>
                        <th className='sort-heading' onClick={() => { _sortFn({ key: 'role', order: order === -1 ? 1 : -1 }) }}>
                            <div className="sort-elem-cell d-inline-flex align-items-center">
                                Role
                                <span className='sort-cell d-inline-flex flex-column align-items-center'>

                                    {sort === 'role' ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">


                                                {(order != 1) ? <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />
                                                    :
                                                    <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />
                                                }

                                            </g>
                                        </svg>
                                    ) : <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                        <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">
                                            <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />

                                            <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />

                                        </g>
                                    </svg>
                                    }
                                </span>
                            </div>
                        </th>
                        <th className='sort-heading' onClick={() => { _sortFn({ key: 'user.email', order: order === -1 ? 1 : -1 }) }}>
                            <div className="sort-elem-cell d-inline-flex align-items-center">
                                Email
                                <span className='sort-cell d-inline-flex flex-column align-items-center'>

                                    {sort === 'user.email' ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">


                                                {(order != 1) ? <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />
                                                    :
                                                    <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />
                                                }

                                            </g>
                                        </svg>
                                    ) : <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                        <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">
                                            <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />

                                            <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />

                                        </g>
                                    </svg>
                                    }
                                </span>
                            </div>
                        </th>
                        <th className='sort-heading' onClick={() => { _sortFn({ key: 'logDetail', order: order === -1 ? 1 : -1 }) }}>
                            <div className="sort-elem-cell d-inline-flex align-items-center">
                                Log
                                <span className='sort-cell d-inline-flex flex-column align-items-center'>
                                    {sort === 'logDetail' ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">


                                                {(order != 1) ? <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />
                                                    :
                                                    <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />
                                                }

                                            </g>
                                        </svg>
                                        : <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">
                                                <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />

                                                <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />

                                            </g>
                                        </svg>
                                    }
                                </span>
                            </div>
                        </th>
                        {/* <th className='sort-heading'>
                        File Name
                        <span className='sort-cell d-inline-flex flex-column align-items-center'>
                        <span className='d-inline-flex up'>
                        <img className='img-fluid' src={require('../../../../assets/img/icons/arrow-triangle-fill-up.svg')} />
                        </span>
                        <span className='d-inline-flex down'>
                        <img className='img-fluid' src={require('../../../../assets/img/icons/arrow-triangle-fill-down.svg')} />
                        </span>
                        </span>
                        </th> */}

                       <th className="text-center sort-heading">
                            <div className="sort-elem-cell d-inline-flex align-items-center">
                                Revision
                            </div>
                        </th>
                        <th className="text-center sort-heading" onClick={() => { _sortFn({ key: 'version', order: order === -1 ? 1 : -1 }) }}>
                            <div className="sort-elem-cell d-inline-flex align-items-center">
                                Version
                                <span className='sort-cell d-inline-flex flex-column align-items-center'>
                                    {sort === 'version' ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">


                                                {(order != 1) ? <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />
                                                    :
                                                    <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />
                                                }

                                            </g>
                                        </svg>
                                        : <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">
                                                <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />

                                                <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />

                                            </g>
                                        </svg>
                                    }
                                </span>
                            </div>
                        </th>
                        <th className="text-center sort-heading" onClick={() => { _sortFn({ key: 'changedByQC', order: order === -1 ? 1 : -1 }) }}>
                            <div className="sort-elem-cell d-inline-flex align-items-center">
                                Change By QC
                                <span className='sort-cell d-inline-flex flex-column align-items-center'>
                                    {sort === 'changedByQC' ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">


                                                {(order != 1) ? <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />
                                                    :
                                                    <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />
                                                }

                                            </g>
                                        </svg>
                                        : <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">
                                                <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />

                                                <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />

                                            </g>
                                        </svg>
                                    }
                                </span>
                            </div>
                        </th>
                        <th className='sort-heading' onClick={() => { _sortFn({ key: 'updatedAt', order: order === -1 ? 1 : -1 }) }}>
                            <div className="sort-elem-cell d-inline-flex align-items-center">
                                Date Modified
                                <span className='sort-cell d-inline-flex flex-column align-items-center'>
                                    {sort === 'updatedAt' ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">


                                                {(order != 1) ? <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />
                                                    :
                                                    <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />
                                                }

                                            </g>
                                        </svg>
                                        : <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
                                            <g id="Group_958" data-name="Group 958" transform="translate(-458 -170)">
                                                <path id="Polygon_5" data-name="Polygon 5" d="M5,0l5,6H0Z" transform="translate(468 184) rotate(180)" />

                                                <path id="Polygon_6" data-name="Polygon 6" d="M5,0l5,6H0Z" transform="translate(458 170)" />

                                            </g>
                                        </svg>
                                    }
                                </span>
                            </div>
                        </th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        documentLogs?.docs?.map((item, index) => {
                            console.log("admin data in doc logs ->", item, index)
                            return (
                                <tr key={index}>
                                    {item?.autoProcessed && item?.autoProcessed == true ? <td>MORi Automation</td> : 
                                        item?.user ? <td>{item?.user?.fname} {item?.user?.lname}</td> : item?.admin ? <td>{item?.admin?.fname} {item?.admin?.lname}</td> : <td>-</td>}
                                    {item?.autoProcessed && item?.autoProcessed == true ? <td></td> : item?.user ? <td>{item?.userRole?.roleName}</td> : item?.admin ? <td>{item?.adminRole?.roleName}</td> : <td>Mori Support</td>}
                                    {item?.autoProcessed && item?.autoProcessed == true ? <td></td> : item?.user ? <td>{item?.user?.email}</td> : item?.admin ? <td>{item?.admin?.email}</td> : <td>-</td>}
                                    {/* <td>{fileData.name}</td> */}
                                    <td>{item?.logDetail}</td>
                                    <td className='text-center'>{item?.revision}</td>
                                    <td className='text-center'>{item?.version}</td>
                                    <td className='text-center'>{item.changedByQC !== undefined ? item.changedByQC.toString().charAt(0).toUpperCase() + item.changedByQC.toString().slice(1).toLowerCase()  : 'False'}</td>
                                    <td>
                                        {/* {moment(item?.updatedAt).format(
                                        "MMM DD,YYYY"
                                    ) + ' at ' + moment(item?.updatedAt).format(
                                        "h:mm a"
                                    )} */}
                                        {(item?.updatedAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={item?.updatedAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail.timezone} dateTime={item?.updatedAt} timeFormat={"h:mm a"} /></> : moment(item?.updatedAt).format(
                                            "MMM DD,YYYY"
                                        ) + ' at ' + moment(item?.updatedAt).format(
                                            "h:mm a"
                                        )}
                                    </td>
                                    <td className='action-cell'>
                                        <Button color='link icon-btn' onClick={() => openModal(item)}>
                                            <FontAwesomeIcon icon={faEye} />
                                        </Button>
                                    </td>
                                </tr>
                            )

                        })
                    }
                </tbody>
            </Table>
            <PaginationBlock2 page={page} limit={limit} organizations={documentLogs} __handleLimit={_handleLimit} __handlePageChange={_handlePageChange} />
            {/* audit-log-detail Modal */}
            <Modal isOpen={modal} toggle={modalToggleHandle} className='audit-log-modal'>
                <ModalHeader>
                    Audit Log Detail
                    <Button color='link' onClick={modalToggleHandle}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="34"
                            height="34"
                            viewBox="0 0 34 34"
                        >
                            <g data-name="Group 651" transform="translate(-1535 -134)">
                                <g
                                    fill="#fff"
                                    stroke="#000"
                                    strokeWidth="2"
                                    data-name="Ellipse 30"
                                    opacity="0.3"
                                    transform="translate(1535 134)"
                                >
                                    <circle cx="17" cy="17" r="17" stroke="none"></circle>
                                    <circle cx="17" cy="17" r="16" fill="none"></circle>
                                </g>

                                <path
                                    d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                                    data-name="Icon ionic-ios-close"
                                    opacity="0.3"
                                    transform="translate(1534.289 132.789)"
                                ></path>
                            </g>
                        </svg>
                    </Button>
                </ModalHeader>
                <ModalBody>
                    <div className='audit-log-rw'>
                        <div className='list-info'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <label className='lbl'>UserName</label>
                                    <span className='desc d-block'>
                                        {documentLogDetail?.user ? <td>{documentLogDetail?.user?.fname} {documentLogDetail?.user?.lname}</td> : documentLogDetail?.admin ? <td>{documentLogDetail?.admin?.fname} {documentLogDetail?.admin?.lname}</td> : <td>-</td>}
                                    </span>
                                </div>
                                <div className='col-md-4'>
                                    <label className='lbl'>Role</label>
                                    <span className='desc d-block'>
                                        {documentLogDetail?.user ? <td>{documentLogDetail?.userRole?.roleName}</td> : documentLogDetail?.admin ? <td>{documentLogDetail?.adminRole?.roleName}</td> : <td>Mori Support</td>}
                                    </span>
                                </div>
                                <div className='col-md-4'>
                                    <label className='lbl'>Version
                                    </label>
                                    <span className='desc d-block'>
                                        {documentLogDetail?.version}
                                    </span>
                                </div>
                                <div className='col-sm-12'>
                                    <label className='lbl'>File Name
                                    </label>
                                    <span className='desc d-block'>
                                        {fileData.name}
                                    </span>
                                </div>
                                <div className='col-sm-12'>
                                    <label className='lbl'>
                                        Date Modified
                                    </label>
                                    <span className='desc d-block'>
                                        {(documentLogDetail?.updatedAt && userDetail?.timezone) ? <><TimezoneClock timezone={userDetail.timezone} dateTime={documentLogDetail?.updatedAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail.timezone} dateTime={documentLogDetail?.updatedAt} timeFormat={"h:mm a"} /></> : moment(documentLogDetail?.updatedAt).format(
                                            "MMM DD,YYYY"
                                        ) + ' at ' + moment(documentLogDetail?.updatedAt).format(
                                            "h:mm a"
                                        )}

                                        {/* {moment(documentLogDetail?.updatedAt).format(
                                            "MMM DD,YYYY"
                                        ) + ' at ' + moment(documentLogDetail?.updatedAt).format(
                                            "h:mm a"
                                        )} */}
                                    </span>
                                </div>
                                <div className='col-sm-12'>
                                    <label className='lbl'>Log Detailed
                                    </label>
                                    <span className='desc d-block'>
                                        {documentLogDetail?.logDetail}
                                    </span>
                                </div>
                                <div className='col-sm-12'>
                                    <label className='lbl'>Process By
                                    </label>
                                    <span className='desc d-block'>
                                        {documentLogDetail?.autoProcessed && documentLogDetail?.autoProcessed == true ? 'MORi Automation' : 
                                        documentLogDetail?.user ? <td>{documentLogDetail?.user?.fname} {documentLogDetail?.user?.lname}</td> : documentLogDetail?.admin ? <td>{documentLogDetail?.admin?.fname} {documentLogDetail?.admin?.lname}</td> : <td>-</td>}
                                    </span>
                                </div>
                                {documentLogDetail?.logDetail == "Returned to Queue" || documentLogDetail?.logDetail == "Assigned to Tech" ? <div className='col-sm-12'>
                                    <label className='lbl'>Triage Resolution
                                    </label>
                                    <span className='desc d-block'>
                                        {documentLogDetail?.triageResolution ? <td>{documentLogDetail?.triageResolution}</td> : <td>-</td>}
                                    </span>
                                </div> : null}
                                {documentLogDetail?.logDetail === "QC Verification" ? <div className='col-sm-12'>
                                    <label className='lbl'>QC Verified
                                    </label>
                                    <span className='desc d-block'>
                                        {documentLogDetail?.QAVerified ? "true" : "false"}
                                    </span>
                                </div> : null}
                                {documentLogDetail?.ReasonForFailure ? <div className='col-sm-12'>
                                    <label className='lbl'>Reason For Failure
                                    </label>
                                    <span className='desc d-block'>
                                        {documentLogDetail?.ReasonForFailure }
                                    </span>
                                </div> : null}
                                {documentLogDetail?.triageReason ? <div className='col-sm-12'>
                                    <label className='lbl'>Triage Reason
                                    </label>
                                    <span className='desc d-block'>
                                        {documentLogDetail?.triageReason }
                                    </span>
                                </div> : null}
                            </div>
                        </div>
                    </div>
                    {documentLogDetail?.updatedTagValidate?.length ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>Validation Changes</div>
                                <div className='card-body'>
                                    <ul className='list-unstyled d-flex flex-wrap'>
                                        {documentLogDetail?.updatedTagValidate?.map((item, index) => (
                                            <li key={index}>
                                                <span>
                                                    {item?.key || item?.oldValue || item?.newValue ? 
                                                    `${item?.key}: ${item?.oldValue !== undefined ? item?.oldValue : "null"} -> ${item?.newValue !== undefined ? item?.newValue : "null"}` : 
                                                    item?.toString()}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {documentLogDetail?.updateTagValidateCheck?.length ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>Validation Accepted</div>
                                <div className='card-body'>
                                    <ul className='list-unstyled d-flex flex-wrap'>
                                        {documentLogDetail?.updateTagValidateCheck?.map((item, index) => (
                                            <li>
                                                <span>
                                                    {item} {/* Access the value dynamically */}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {documentLogDetail?.updateTagValidateCheckN?.length ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>Validation Updated</div>
                                <div className='card-body'>
                                    <ul className='list-unstyled d-flex flex-wrap'>
                                        {documentLogDetail?.updateTagValidateCheckN?.map((item, index) => (
                                            <li>
                                                <span>
                                                    {item} {/* Access the value dynamically */}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {documentLogDetail?.updateTagErrorValidate?.length ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>Errors Validated</div>
                                <div className='card-body'>
                                    <ul className='list-unstyled d-flex flex-wrap'>
                                        {documentLogDetail?.updateTagErrorValidate?.map((item, index) => (
                                            <li>
                                                <span>
                                                    {item} {/* Access the value dynamically */}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {documentLogDetail?.updatedTextCorrect?.length ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>Text Updated</div>
                                <div className='card-body'>
                                    <ul className='list-unstyled d-flex flex-wrap'>
                                        {documentLogDetail?.updatedTextCorrect?.map((item, index) => (
                                            <li key={index}>
                                                <span>
                                                    {item?.key || item?.oldValue || item?.newValue ? 
                                                    `${item?.key}: ${item?.oldValue !== undefined ? item?.oldValue : "null"} -> ${item?.newValue !== undefined ? item?.newValue : "null"}` : 
                                                    item?.toString()}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {documentLogDetail?.updatedTagsCorrect?.length ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>Tags Updated</div>
                                <div className='card-body'>
                                    <ul className='list-unstyled d-flex flex-wrap'>
                                        {documentLogDetail?.updatedTagsCorrect?.map((item, index) => (

                                            <li key={index}>
                                                <span>
                                                    {item?.key || item?.oldValue || item?.newValue ? 
                                                    `${item?.key}: ${item?.oldValue !== undefined ? item?.oldValue : "null"} -> ${item?.newValue !== undefined ? item?.newValue : "null"}` : 
                                                    item?.toString()}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {documentLogDetail?.updateTagCorrectCheck?.length ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>Text Accepted</div>
                                <div className='card-body'>
                                    <ul className='list-unstyled d-flex flex-wrap'>
                                        {documentLogDetail?.updateTagCorrectCheck?.map((item, index) => (
                                            <li>
                                                <span>
                                                    {item} {/* Access the value dynamically */}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {documentLogDetail?.assignedBy ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>{documentLogDetail?.assign ? "Assigned By" : "Unassigned By"}</div>
                                <div className='card-body'>
                                    <span>{documentLogDetail?.assignedByName}</span>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {documentLogDetail?.errorMessages?.length ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>Error Messages</div>
                                <div className='card-body'>
                                    <div className="row">
                                        {documentLogDetail?.errorMessages?.map((item, index) => (
                                            <div className="col-sm-12 validation-error-list">
                                            <Label className="">
                                                <span className="txt">
                                                    <strong>{item?.resultKey}</strong> {' : ' + item?.errorMessage != null ? item?.errorMessage : '' }
                                                </span>
                                            </Label>
                                        </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {documentLogDetail?.otherReason ? (
                        <div className='audit-log-rw'>
                            <div className='list-info'>
                                <div className='row'>
                                    <div className='col-sm-12'>
                                        <label className='lbl'>Other reason
                                        </label>
                                        <span className='desc d-block'>
                                            {documentLogDetail?.otherReason}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>): null }
                    {documentLogDetail?.recipientsNames?.length ? (
                        <div className='audit-log-rw'>
                            <div className='card updates-info'>
                                <div className='card-header'>Recipient Names</div>
                                <div className='card-body'>
                                    <ul className='list-unstyled d-flex flex-wrap'>
                                        {documentLogDetail?.recipientsNames?.map((item, index) => (
                                            <li>
                                                <span>
                                                    {item?.email}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </ModalBody>
            </Modal>
        </>
    );
};

export default Listing;
